import type { RealtimeEventListenerBuilder } from './realtime-event-listener';
import { createRealtimeEventListenerBuilder as _createRealtimeEventListenerBuilder } from './realtime-event-listener';

export const createRealtimeEventListenerBuilder = ({
    baseUrl,
}: {
    readonly baseUrl: URL;
}): RealtimeEventListenerBuilder => {
    return _createRealtimeEventListenerBuilder(baseUrl);
};
